import React from 'react'
import Navbar from '../navbar/Navbar'

const Layout = (WrappedComponents) => {
    return function Layout(props) {
        return (
            <div>
                <Navbar />
                <WrappedComponents {...props} />
            </div>
        )
    }
}

export default Layout;
